/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tabs-modular.vue?vue&type=template&id=68688c6c&scoped=true&"
import script from "./tabs-modular.vue?vue&type=script&lang=ts&"
export * from "./tabs-modular.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68688c6c",
  null
  
)

export default component.exports